import { useImpersonation } from '../context/ImpersonationContext';

export const IMPERSONATE_HEADER = 'X-Impersonate-User-Id';

/**
 * Build fetch headers — Authorization from opsToken plus, when an
 * impersonation is active, X-Impersonate-User-Id with the impersonated
 * staff member's id (Employee.id from ViewAsSelector; backend resolves
 * via OpsUser.therapistId fallback).
 *
 * Non-mutating: returns a fresh object each call so callers can spread
 * additional headers in (e.g. Content-Type for POST bodies).
 */
export function buildAuthHeaders(opsToken, impersonatedAs) {
  const headers = {};
  if (opsToken) headers['Authorization'] = `Bearer ${opsToken}`;
  if (impersonatedAs?.employeeId) headers[IMPERSONATE_HEADER] = impersonatedAs.employeeId;
  return headers;
}

/**
 * React hook variant — pulls impersonatedAs from ImpersonationContext.
 * Use this at the top of components that fetch their own data so every
 * GET automatically carries the impersonation header when active.
 */
export function useApiHeaders(opsToken) {
  const { impersonatedAs } = useImpersonation();
  return buildAuthHeaders(opsToken, impersonatedAs);
}
